// Vue 3: Use createI18n instead of new VueI18n
import { createI18n } from "vue-i18n"

function loadLocaleMessages() {
  const locales = import.meta.glob("./locales/*.json", { eager: true })
  const messages = {}

  Object.keys(locales).forEach((key) => {
    const matched = key.match(/\.\/locales\/([\w-]+)\.json$/i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales[key].default || locales[key]
    }
  })

  return messages
}

// Vue 3: Use createI18n with legacy: true for $t() compatibility
export default createI18n({
  legacy: false, // Important: enables Vue 2 style $t() usage in templates
  locale: localStorage.getItem("locale") || "ru",
  fallbackLocale: "ru",
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
  silentFallbackWarn: true,
})

// Export SUPPORT_LOCALES for use in other files
export const SUPPORT_LOCALES = ["ru", "uz-cyrl", "uz-latn", "en"]
